import { render, staticRenderFns } from "./GradeAnalysisSch_week.vue?vue&type=template&id=606667ed&scoped=true&"
import script from "./GradeAnalysisSch_week.vue?vue&type=script&lang=js&"
export * from "./GradeAnalysisSch_week.vue?vue&type=script&lang=js&"
import style0 from "./GradeAnalysisSch_week.vue?vue&type=style&index=0&id=606667ed&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606667ed",
  null
  
)

export default component.exports